import { IoIosMail } from "react-icons/io";
import { FaUser, FaPhoneAlt } from "react-icons/fa";

export const INPUTS = [
  {
    id: 1,
    type: "text",
    placeholder: "Name",
    name: "user_name",
    icon: <FaUser fontSize={20} className="absolute top-1/2 -translate-y-1/2 left-4" />,
  },
  {
    id: 2,
    type: "email",
    placeholder: "Email",
    name: "user_email",
    icon: <IoIosMail fontSize={20} className="absolute top-1/2 -translate-y-1/2 left-4" />,
  },
  {
    id: 3,
    type: "tel",
    placeholder: "Phone",
    name: "user_phone",
    icon: <FaPhoneAlt fontSize={20} className="absolute top-1/2 -translate-y-1/2 left-4" />,
  },
];
